import { ModelBase } from './model-base';
import { ModelMetadataContainer } from './model-metadata-container';
import { CollectionPropertyConfig, PropertyMetadata } from './property-metadata';

export function Collection(config: Partial<CollectionPropertyConfig>): PropertyDecorator {
    return (target: Object, propertyKey: string | symbol): void => {
        const key = propertyKey as string;
        const reflectedMetadataType = Reflect.getMetadata('design:type', target, key);
        const propertyMetadata: PropertyMetadata = {
            propertyName: key,
            type: reflectedMetadataType,
            config: {
                identifiable: false,
                nullable: Object.getPrototypeOf(reflectedMetadataType) === ModelBase,
                type: config.type!,
                ...config
            }
        };

        const modelMetadata: ModelMetadataContainer = Reflect.getMetadata('skl:model', target.constructor) || new ModelMetadataContainer();

        modelMetadata.setPropertyMetadata(key, propertyMetadata);

        Reflect.defineMetadata('skl:model', modelMetadata, target.constructor);
    };
}
